import React, { useContext } from 'react';
import { FormContext, FormSchemaFields } from '@sw-sw/lib-form';
import { UIControlType } from '@sw-sw/lib-form-control-types';
import FormModal from '../../Shared/form/modal/FormModal';

const PublicInfoModal = ({ onSubmit, onCancel }) => {
  const formContext = useContext(FormContext);

  const getSchema = () => {
    return {
      name: {
        label: 'Name*',
        type: UIControlType.text,
        validation: {
          required: true,
        },
        placeholder: 'Enter your name',
      },
      email: {
        label: 'Email*',
        type: UIControlType.email,
        validation: {
          format: 'email',
          required: true,
        },
        placeholder: 'Enter your email',
      },
      company: {
        label: 'Company',
        type: UIControlType.text,
        placeholder: 'Enter your company (optional)',
      },
    };
  };

  const handleSubmit = async () => {
    if (formContext.isValid) {
      // Normalize email
      const normalizedData = {
        ...formContext.value,
        email: formContext.value.email?.trim().toLowerCase(),
        name: formContext.value.name?.trim(),
        company: formContext.value.company?.trim() || '',
      };

      await onSubmit(normalizedData);
    }
  };

  return (
    <FormModal
      modalProps={{
        title: 'Welcome',
        subtitle: 'Please provide your information to access this project',
        classes: 'visitor-info-modal',
      }}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      submitText='Continue'
      submitDisabled={!formContext.isValid}
      cancelText='Cancel'
    >
      <FormSchemaFields
        schema={getSchema()}
        formData={formContext.value}
        onChange={formContext.set}
        initialFormData={{}}
      />
    </FormModal>
  );
};

export default PublicInfoModal;
